import 'ui-core/components/figure-viewer/js/figure-viewer-script';

(function () {
    const figureViewer = UX.figureViewer;
    const figureNumbers = document.querySelectorAll('.figure__image');
    let nodesToBeDisabled = [];
    let getSiblings = function (e) {
        let siblings = [];
        if (!e.parentNode) {
            return siblings;
        }
        let sibling = e.parentNode.firstChild;
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== e) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
        return siblings;
    };

    //this is a recursive function to disable the least possible nodes in the DOM tree to avoid interacting with the background content
    function disableNodes(node) {
        nodesToBeDisabled.push(...getSiblings(node));
        if (node.parentElement !== document.body) {
            nodesToBeDisabled.push([...getSiblings(node.parentElement)]);
            node = node.parentElement;
            disableNodes(node);
        } else {
            nodesToBeDisabled.forEach(nodeElement => {
                nodeElement.inert = true;
            });
        }
    }

    figureViewer.removeFigureTitle = function () {};

    figureViewer.additionalBrowse = function () {
        if ($('#pane-pcw-figures').hasClass('empty')) {
            figureViewer.$browseContainer.empty();
            figureViewer.$figures.each(function () {
                let $fig = $(this).clone(true);
                let $figureLinks = $fig.find('.figure-links');

                if ($figureLinks.length) {
                    $figureLinks.remove();
                }
                figureViewer.$browseContainer.append($fig);
            });
        }
    };

    figureViewer.on.additionalOnShow = function () {
        const adFocusableEl = document.querySelector('.js--adFocusableEl');
        if (adFocusableEl && adFocusableEl.tabIndex === -1) {
            adFocusableEl.tabIndex = 0;
        }
        const figureViewer = document.querySelector('.figure-viewer');
        disableNodes(figureViewer);
    };

    figureViewer.on.additionalOnHide = function () {
        const adFocusableEl = document.querySelector('.js--adFocusableEl');
        if (adFocusableEl && adFocusableEl.tabIndex === 0) {
            adFocusableEl.tabIndex = -1;
        }
        nodesToBeDisabled.forEach(element => {
            element.inert = false;
        });
        figureViewer.$focusedElementBeforeOpened.focus();
    };

    if (figureNumbers.length === 1) {
        figureViewer.$figureNav.hide();
    }

    // embo customization
    figureViewer.additionalShow = function () {
        if (!figureViewer.isMobile) {
            figureViewer.$captionRegion.addClass('js-open');
            figureViewer.$contentRegion.addClass('js-open');
        } else {
            figureViewer.$captionRegion.removeClass('js-open');
            figureViewer.$contentRegion.removeClass('js-open');
        }
    };
    // embo customization
    figureViewer.additionalBehaviorOnShow = function ($el) {
        let content = $el.find('figcaption .figure__caption'),
            figTitle = $el.find('.fig-title').length ? $el.find('.fig-title') : '';

        if (content.data('originalContent') !== undefined) {
            figTitle = figTitle.length ? `<p><b>${figTitle.html()}</b></p>` : '';
            content = `${figTitle} ${content.data('originalContent')} ${$el.find('.figure-block').html() || ''}`;
        } else {
            content = $el.find('figcaption, .figcaption').clone();
            content.find('.captionLabel').remove();
        }
        return content;
    };
    // embo customization
    figureViewer.height = function (element) {
        let $windowsHeight = $(window).innerHeight();
        figureViewer.$topRegHeight = $('.figure-viewer__reg__top').innerHeight();
        let $height = $windowsHeight - figureViewer.$topRegHeight; //LIT-360726
        $('.figure-viewer__cent__left').find('figure').height($height);
    };
})();
